import React, { useState, useRef, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import store from "../store";


const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Sintony";
  font-size: 1rem;
  font-weight: bold;
  line-height: normal;
  margin: 0;
  padding: 0;
  padding: ${4 / 16}rem ${21 / 16}rem;
  border-radius: 50px;
  box-shadow: 0 0 ${10 / 16}rem rgba(0, 0, 0, 0.13);


  @media (min-width: 1024px) {
    height: 40px;
    padding: ${8 / 16}rem 0;
    font-size: ${18 / 16}rem;
    width: ${200/16}rem;
  }

  svg {
    ${(props) => props.iconWidth && `width: ${props.iconWidth};`};
    ${(props) => props.iconHeight && `height: ${props.iconHeight};`};
  }
  svg path{
    ${(props) => (props.fillColor ? `fill: ${props.fillColor};` : "")}
    ${(props) => (props.strokeColor ? `stroke: ${props.strokeColor};` : "")}
  }
  svg line{
    ${(props) => (props.strokeColor ? `stroke: ${props.strokeColor};` : "")}
  }
  span {
    padding-left: 0;
  }

  color: ${(props) => props.theme.textDarkDefault};
  background-color: ${(props) => props.theme.bgDarkDefault};
  border: none;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.bgDarkHover};
    span {
      color: ${(props) => props.theme.textDarkDefault};
    }
  }
  &:active {
    cursor: pointer;
    background-color: ${(props) => props.theme.bgDarkClick};
  }

  //Prop specific effects
  ${(props) =>
    props.matchIconFillToText &&
    `
    &.light svg path{
      fill: ${props.theme.textLightDefault};
    }
    &.dark svg path {
      fill: ${props.theme.textDarkDefault};
    }
  `}
  ${(props) =>
    props.matchIconStrokeToText &&
    `
    &.light svg line {
      stroke: ${props.theme.textLightDefault};
    }
    &.dark svg line {
      stroke: ${props.theme.textDarkDefault};
    }
  `}

  // Themes
  &.dark svg path, &.dark svg line {
    stroke: ${(props) => props.theme.textDarkDefault};
  }
  &.light {
    color: ${(props) => props.theme.textLightDefault};
    background-color: ${(props) => props.theme.bgLightDefault};
    border: 1px solid ${(props) => props.theme.borderLightDefault};

    svg path, svg line {
      stroke: ${(props) => props.theme.textLightDefault};
    }

    &:hover {
      background-color: ${(props) => props.theme.bgLightHover};
      border-color: ${(props) => props.theme.borderLightHover};
      span {
      color: ${(props) => props.theme.textLightDefault};
    }
    }
    &:active {
      background-color: ${(props) => props.theme.bgLightClick};
      border-color: ${(props) => props.theme.borderLightClick};
      opacity: 73%;
    }
  }

  &.pl span {
    padding-left: .5rem;
  }

  &.wide {
    width: 9.5rem;
  }

  &.form-submit {
    color: ${(props) => props.theme.textCandleForm};
    background-color: ${(props) => props.theme.bgFormControls};
    border: 1px solid ${(props) => props.theme.borderFormControl};

    & span {
      color: inherit;
    }

    svg line, svg path {
      stroke: ${(props) => props.theme.textCandleForm};
    }

    &:hover {
      background-color: ${(props) => props.theme.bgLightHover};
      border-color: ${(props) => props.theme.borderLightHover};
    }
    &:active {
      background-color: ${(props) => props.theme.bgLightClick};
      border-color: ${(props) => props.theme.borderLightClick};
    }

  }
  &.form-submit-active {
    color: #806922;
    background-color: ${(props) => props.theme.bgFormControls};
    border: 1px solid ${(props) => props.theme.borderFormControl};

    & span {
      color: inherit;
    }

    svg line, svg path {
      stroke: #806922;
    }

    &:hover {
      background-color: ${(props) => props.theme.bgLightHover};
      border-color: ${(props) => props.theme.borderLightHover};
    }
    &:active {
      background-color: ${(props) => props.theme.bgLightClick};
      border-color: ${(props) => props.theme.borderLightClick};
    }

  }

  &.menu-button {
    background-color: transparent;
    color: ${(props) => props.theme.textMenu};
    font-size: ${12 / 16}rem;
    text-decoration: none;
    line-height: 1rem;

    svg {
      width: auto;
      height: 24px;
    }
  }

  &.back-dark {
    color: ${(props) => props.theme.textDarkDefault};
    background-color: ${(props) => props.theme.bgDarkDefault};
    border-left: none;
    border-radius: 0 50px 50px 0;
    width: 6rem;

    span {
      padding-left: 0;
      padding-right: .75rem;
    }

    &:hover {
      background-color: ${(props) => props.theme.bgLightHover};
      border-color: ${(props) => props.theme.borderLightHover};
    }
    &:active {
      background-color: ${(props) => props.theme.bgLightClick};
      border-color: ${(props) => props.theme.borderLightClick};
    }

    svg path, svg line {
      stroke: ${(props) => props.theme.textDarkDefault};
    }
  }
  &.back {
    color: ${(props) => props.theme.textBackButton};
    background-color: ${(props) => props.theme.bgButtonLightDefault};
    border-left: none;
    border-radius: 0 50px 50px 0;
    width: 6rem;

    span {
      padding-left: 0;
      padding-right: .75rem;
    }

    &:hover {
      background-color: ${(props) => props.theme.bgDarkHover};
    }
    &:active {
      background-color: ${(props) => props.theme.bgDarkHover};
    }

    svg path, svg line {
      stroke: ${(props) => props.theme.textBackButton};
    }
  }

  &.blank {
    background-color: transparent;
    color: black;
    border: none;

    &:hover {
      background-color: transparent;
    }
    &:active {
      background-color: transparent;
    }
  }

  &.header {
    background-color: transparent;
    box-shadow: none;
    justify-content: flex-start;

    svg path, svg line {
      stroke: ${(props) => props.headerColor};
      width: 32;
      height: 32;

      @media (min-width: 1024px) {
        width: 48;
        height: 48;
      }
    }

    &:hover {
      background-color: transparent;
    }
    &:active {
      background-color: transparent;
    }
  }

  &.play {
    width: 32px;
    height: 32px;
    position: relative;
    top: 0%;
    margin-right: 0;
    //transform: translateY(-50%);
    z-index: 111;

    svg {
      width: 32px;
      height: 32px;
    }
    svg path, svg line {
      stroke: ${(props) => props.theme.textDarkDefault};
      fill: ${(props) => props.theme.textDarkDefault};
    }
  }

  &.icon-arrow {
    color: ${(props) => props.theme.textDarkDefault};
    background-color: ${(props) => props.theme.bgDarkDefault};
    border: 1px solid ${(props) => props.theme.textDarkDefault};
    width: 26px;
    height: 26px;
  }
  &.icon-arrow.left-arrow {
    position: absolute;
    bottom: -2.25rem;
    left: -1.125rem;
    width: 2.25rem;
    height: 2.25rem;
    background: transparent;
    box-shadow: none;
    border: none;
    transform: translateY(-50%);
    border: 1px solid ${(props) => props.theme.textDarkDefault};
    svg {
      width: 100%;
      height: 100%;
    }
  }
  &.icon-arrow.right-arrow {
    position: absolute;
    bottom: -2.25rem;
    right: -1.125rem;
    width: 2.25rem;
    height: 2.25rem;
    background: transparent;
    box-shadow: none;
    border: none;
    transform: translateY(-50%);
    border: 1px solid ${(props) => props.theme.textDarkDefault};
    svg {
      width: 100%;
      height: 100%;
    }
  }

  &.social {
    background-color: transparent;
  }

  &.carousel {
    width: 48px;
    height: 48px;
    font-size: ${24 / 16}rem;
    background-color: transparent;
    color: ${(props) => props.theme.textLightDefault};
  }

  &.hotspot {
    color: ${(props) => props.theme.textLightDefault};
    background-color: ${(props) => props.theme.bgLightDefault};
    width: ${177 / 16}rem;
    height: ${40 / 16}rem;
    border: ${1 / 16}rem solid ${(props) => props.theme.borderLightDefault};
    position: relative;
    top: 0%;
    margin-right: 0;
    //transform: translateY(-50%);
    z-index: 111;
  }

  &.captionBack {
    color: ${(props) => props.theme.textBackButton};
    background-color: ${(props) => props.theme.bgButtonLightDefault};
    border: ${1 / 16}rem solid ${(props) => props.theme.borderLightDefault};
    border-left: none;
    width:6rem;
    border-radius: 0 50px 50px 0; // flat left side

    &:hover {
      background-color: ${(props) => props.theme.bgDarkHover};
    }
    &:active {
      background-color: ${(props) => props.theme.bgDarkHover};
    }
  }
  // Special Cases: Styles for Unique Scenarios

  // Button Stacking: Style for buttons that are on top of other buttons
  &.button-on-top {
    margin-bottom: ${9.5 / 16}rem;
  }

  &.exit {
    background-color: transparent;
    color: white;
    border: none;
    top: 2.5rem;
    right: 1rem;
    position: absolute;
    z-index: 90;
    box-shadow: none;
    width: 5rem;

    &:hover {
      background-color: transparent;
    }
    &:active {
      background-color: transparent;
    }
  }

  &.white-outline {
    svg {
      path {
        fill: #FFF;
      }
      rect {
        fill: #FFF;
      }
    }
  }

  &.welcome-video-position {
    position: absolute;
    top: 24px;
    right: 6px;
    z-index: 90;
    width: 48px;
    @media (min-width: 1024px) {
    }
  }
`;

const ButtonContent = styled.span`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  line-height: normal;
  padding: 0;
`;

const Button = ({
  label,
  icon,
  classState,
  type,
  action,
  addClass,
  addStyle,
  isLink,
  link,
  matchIconFillToText,
  matchIconStrokeToText,
  iconWidth,
  iconHeight,
}) => {
  const [state, setState] = useState(store.initialState);
  const sub = useRef(null);

  useLayoutEffect(() => {
    sub.current = store.subscribe(setState);
    store.init();
    return () => {
      store.unsubscribe(sub.current);
    };
  }, []);

  return (
    <StyledButton
      onClick={action}
      className={`${type} ${classState} ${
        !label && icon ? "icon-only" : ""
      } ${addClass}`}
      style={addStyle}
      as={isLink ? "a" : "button"}
      href={isLink ? link : ""}
      target={isLink ? "_blank" : ""}
      disabled={state === "inactive"}
      matchIconFillToText={matchIconFillToText}
      matchIconStrokeToText={matchIconStrokeToText}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      headerColor={state.headerThemeColor}
    >
      <ButtonContent>
        {icon && type === "icon-first" && <>{icon}</>}
        {label && <>{label}</>}
        {icon && type !== "icon-first" && <>{icon}</>}
      </ButtonContent>
    </StyledButton>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.object,
  state: PropTypes.string,
  type: PropTypes.string,
  action: PropTypes.func,
  addClass: PropTypes.string,
  addStyle: PropTypes.object,
  isLink: PropTypes.bool,
  link: PropTypes.string,
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
};

Button.defaultProps = {
  label: null,
  icon: null,
  state: null,
  type: null,
  action: null,
  addClass: null,
  addStyle: null,
  isLink: false,
  link: "",
  fillColor: null,
  strokeColor: null,
};

export default Button;
